import React, { useEffect } from "react";
import '../../../sass/components/flexibleModules/homepage/_components.HomepageIconsDescriptionModuleSafari.scss';

const HomepageIconsDescriptionModuleSafari = ({ data }) => {

    useEffect(() => {
       console.log('test 1');
    }, []);

    return (
        <div className={`cp-homepageIconsDescriptionModule cp-safariOnly`}>
            <div className="cp-homepageIconsDescriptionModule__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.homepageIconsDescriptionModuleHeader &&
                    <>
                        <h2>{data.homepageIconsDescriptionModuleHeader}</h2>
                        <span className="l__divider"></span>
                    </>
                }
                {data.homepageIconsDescriptionModuleRepeaterSections &&
                    <div className="cp-homepageIconsDescriptionModule__sections">
                        <div className="cp-homepageIconsDescriptionModule__sections-section l--flex">
                            <div className="cp-homepageIconsDescriptionModule__sections-sectionLeft l--safari">
                                <>
                                    {
                                        data.homepageIconsDescriptionModuleRepeaterSections.map((iconSection, index) => (
                                            <div className="cp-homepageIconsDescriptionModule__sections-sec l--mobile l--flex" key={index}>
                                                {index === 0 &&
                                                    <>
                                                        <div className="l__icon">
                                                            {iconSection.repeaterSectionsIcon &&
                                                                <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                            }
                                                        </div>
                                                    </>
                                                }
                                                {index === 1 &&
                                                    <>
                                                        <div className="l__icon">
                                                            {iconSection.repeaterSectionsIcon &&
                                                                <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                            }
                                                        </div>
                                                    </>
                                                }
                                                {index === 2 &&
                                                    <>
                                                        <div className="l__icon">
                                                            {iconSection.repeaterSectionsIcon &&
                                                                <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                            }
                                                        </div>
                                                    </>
                                                }
                                                {index === 3 &&
                                                    <>
                                                        <div className="l__icon">
                                                            {iconSection.repeaterSectionsIcon &&
                                                                <img loading="lazy" src={iconSection.repeaterSectionsIcon.sourceUrl} alt={iconSection.repeaterSectionsIcon.altText} />
                                                            }
                                                        </div>
                                                    </>
                                                }
                                                <div className="l__content">
                                                    {iconSection.repeaterSectionsHeader &&
                                                        <h4>{iconSection.repeaterSectionsHeader}</h4>
                                                    }
                                                    {iconSection.repeaterSectionsTeaser &&
                                                        <p dangerouslySetInnerHTML={{ __html: iconSection.repeaterSectionsTeaser }} />
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div >
    );
}

export default HomepageIconsDescriptionModuleSafari;